import { render } from "./Infobar.vue?vue&type=template&id=1d612488&ts=true"
import script from "./Infobar.vue?vue&type=script&lang=ts"
export * from "./Infobar.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__